import { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";

export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const loc = useLocation();

  const fetchCount = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications/unread");
      setCount(data.count || 0);
    } catch (e) {}
  }, []);

  useEffect(() => {
    fetchCount();
    const t = setInterval(fetchCount, 30000);
    return () => clearInterval(t);
  }, [fetchCount]);

  // When user visits dashboard, mark as seen
  useEffect(() => {
    if (loc.pathname === "/" && count > 0) {
      const t = setTimeout(async () => {
        try {
          await api.post("/notifications/mark-seen");
          setCount(0);
        } catch (e) {}
      }, 3000);
      return () => clearTimeout(t);
    }
  }, [loc.pathname, count]);

  return (
    <div className="relative" data-testid="notification-bell">
      <Bell className="w-4 h-4 text-slate-400" />
      <AnimatePresence>
        {count > 0 && (
          <motion.span
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            className="absolute -top-1.5 -right-2 min-w-[16px] h-[16px] px-1 rounded-full bg-cyan-400 text-[10px] font-bold text-slate-950 flex items-center justify-center pulse-glow"
            data-testid="notification-count"
          >
            {count > 99 ? "99+" : count}
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  );
}
